import { redirect } from "react-router"

import { toHttpError } from "@/utils/api"
import { buildSignInRedirectUrl } from "@/utils/auth/auth"
import { isUnauthorizedError } from "@/utils/queryClient"

export const redirectToSignInFromRequest = (request: Request): Response => {
  const url = new URL(request.url)
  return redirect(buildSignInRedirectUrl(url.pathname, url.search))
}

export const resolveLoaderError = (
  error: unknown,
  request: Request
): Response => {
  if (isUnauthorizedError(error)) {
    return redirectToSignInFromRequest(request)
  }

  const httpError = toHttpError(error)

  if (httpError.transport.canceled) {
    throw new DOMException("The operation was aborted.", "AbortError")
  }

  throw httpError
}
